import { makeMap } from './utils';
import ctt from './const/index';

const deviceMods = type => {
  // const mods = ['bioMod', 'cwaMod', 'smokeMod', 'tvocMod', 'sysMod', 'gcameraMod', 'nuclearMod', 'ecMod', 'weatherMod'];
  let res;
  switch (type) {
    case ctt.FCBR_100_v1:
    case ctt.FCBR_100_v2:
    case ctt.FCBR_100F:
      res = ['bioMod', 'cwaMod', 'smokeMod', 'tvocMod', 'sysMod'];
      break;
    case ctt.FCBR_100G:
      res = ['bioMod', 'cwaMod', 'smokeMod', 'tvocMod', 'sysMod', 'gcameraMod'];
      break;
    case ctt.FCBR_100CP:
      res = ['cwaMod', 'smokeMod', 'tvocMod', 'sysMod', 'ecMod', 'weatherMod'];
      break;
    case ctt.FCBR_100C:
      res = ['cwaMod', 'smokeMod', 'tvocMod', 'sysMod'];
      break;
    case ctt.FCBR_100CV2:
      res = ['cwaMod', 'tvocMod', 'sysMod'];
      break;
    case ctt.FCBR_100PRO:
      res = ['bioMod', 'cwaMod', 'smokeMod', 'tvocMod', 'sysMod', 'nuclearMod', 'weatherMod'];
      break;
    case ctt.FCBR_100B:
      res = ['bioMod', 'smokeMod', 'sysMod', 'tvocMod'];
      break;
    case ctt.FCBR_100M:
      res = ['cwaMod', 'smokeMod', 'tvocMod', 'sysMod'];
      break;
    default:
      res = [];
      break;
  }
  res = res.join(',');
  return res;
};

/**
 * 过滤多余的mods
 * @param {String} type 设备类型
 * @param {*} res socket返回数据
 * @returns 处理后res
 */
export function socketModsFilter(type, res) {
  if (!type || !deviceMods(type)) return res;
  const has = makeMap(deviceMods(type));
  const { mods } = res || {};
  Object.keys(mods || {}).forEach(key => {
    // 删除不包含模块
    if (!has(key)) delete mods[key];
  });
  return res;
}
